import styled from 'styled-components';

import { PhoneInput } from '@libs/components';

import { SectionDescription } from '../section/SectionDescription';

export const ActionWrapper = styled.div`
  margin-top: 2rem;
`;

export const CodeWrapper = styled.div`
  margin: 1.6rem 0 2.4rem;
`;

export const ErrorWrapper = styled.div`
  margin-top: 1.8rem;
  height: 2rem;
`;

export const Description = styled(SectionDescription)`
  margin-top: 4rem;
  max-width: 36.6rem;
`;

export const PhoneForm = styled.form`
  vertical-align: middle;
  width: 100%;
  padding: 0 2.2rem 2.2rem;
  margin-top: 4.8rem;
  ${({ theme }) => theme.media.tablet`
    // padding: 0 0 0.8rem;
    padding: 0 3.7rem 3.7rem;
    min-width: 44rem;
  `};
`;

export const CustomDescription = styled(Description)`
  width: 40rem;
`;

export const CustomPhoneInput = styled(PhoneInput)`
  .input-button {
    max-width: 8.2rem;

    ${({ theme }) => theme.media.mobileL`
    max-width: 10.2rem;
  `};
  }
`;
